import React from 'react';
// import { useMakePHPRequest } from '../../../common/useMakePHPRequest';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { useMutation } from 'react-query';
import { getApiMutation } from '../../../services/rest/getApiMutation';

export function DeleteRingGroupModal({
  setRefetchToggleForBusinessGroups,
  enqueueSnackbarWithStyles,
  userAtom,
  setUserAtom,
  selected,
  handleClose,
  show,
}) {
  // const makeRequest = useMakePHPRequest({
  //   userAtom: userAtom.contents,
  // });
  const mutation = useMutation(getApiMutation(userAtom, setUserAtom));
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (values.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            // const { response: _response } = await makeRequest({
            //   methodName: methodNameEnum.DELETE_GROUP,
            //   payload: {
            //     userid: '',
            // groupid: values.selected[i].maingroupid,
            //   },
            // });
            const data = {
              call: methodNameEnum.DELETE_GROUP,
              apikey: userAtom.apikey,
              businessid: userAtom.businessid,
              groupid: values.selected[i].maingroupid,
            };
            const response = await mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_GROUP,
              payload: data,
            });
            if (!response?.data?.success) {
              enqueueSnackbarWithStyles({
                message:
                  'Looks like we encountered an error deleting these Ring Group(s)',
                alertProps: { severity: 'warning' },
              });
              break;
            }
          }
        }
        handleClose();
        setRefetchToggleForBusinessGroups({});
        enqueueSnackbarWithStyles({
          message: `Successfully Deleted ${values.selected.length} Ring Group(s)`,
          alertProps: { severity: 'success' },
        });
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        selected: selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Ring Group(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                You are about to delete {formik.values.selected.length} selected
                Ring Group(s), this procedure is not reversible.
              </p>
              <p>Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
